export const namespaced = true

export const state = {
  user: { id: '1', name: 'Lynnie Boy' },
  test: { somePropert: 'prop1', somethingelse: 'huh?' }
}

export const actions = {
  createEvent({ dispatch, rootState }, event) {
    console.log('user creating event is ' + rootState.user.user.name)
    //this is an example of calling anther modules actions
    dispatch(
      'event/createEvent', //event to call
      event, //payload
      { root: true } //look for this action at root of store
    )
    console.log('success')
  }
}
